import { useEffect, useState } from 'react';
import { isStale, VERSION_STALE_EVENT } from '../utils/appVersion';

// „Új verzió érhető el" sáv (2026-09-24). Ellenőriz: betöltéskor, 5 percenként, és amikor
// a lap újra előtérbe kerül; valamint minden érzékeny passkey-művelet előtt (a
// StepUpContext hívja az `isStale`-t, és találatkor ez a sáv jelenik meg).
const CHECK_EVERY_MS = 5 * 60 * 1000;

export default function NewVersionBanner() {
  const [stale, setStale] = useState(false);

  useEffect(() => {
    const onStale = () => setStale(true);
    const check = () => { if (document.visibilityState === 'visible') isStale(); };
    window.addEventListener(VERSION_STALE_EVENT, onStale);
    document.addEventListener('visibilitychange', check);
    const t = setInterval(check, CHECK_EVERY_MS);
    check();
    return () => {
      window.removeEventListener(VERSION_STALE_EVENT, onStale);
      document.removeEventListener('visibilitychange', check);
      clearInterval(t);
    };
  }, []);

  if (!stale) return null;
  return (
    <div role="alert" style={{
      position: 'fixed', left: 0, right: 0, top: 0, zIndex: 2000,
      paddingTop: 'calc(env(safe-area-inset-top, 0px) + 0.6rem)', paddingBottom: '0.6rem',
      paddingLeft: '1rem', paddingRight: '1rem',
      background: 'var(--warning)', color: '#111827', display: 'flex', gap: 12,
      alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap',
      fontSize: '0.85rem', fontWeight: 600, boxShadow: 'var(--shadow)',
    }}>
      <span>Új verzió érhető el. Frissítsd az oldalt — utalás és más megerősítést kérő
        művelet csak az új verzióval indítható.</span>
      <button onClick={() => window.location.reload()} style={{
        background: '#111827', color: '#fff', border: 'none', borderRadius: 'var(--radius)',
        padding: '0.35rem 0.9rem', fontWeight: 700, cursor: 'pointer',
      }}>Frissítés</button>
    </div>
  );
}
